import { render } from "./ParticipantNotes.vue?vue&type=template&id=f0288bac&ts=true"
import script from "./ParticipantNotes.vue?vue&type=script&lang=ts"
export * from "./ParticipantNotes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__